'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _datalist = _interopRequireDefault(require("../datalist"));

var _translate = _interopRequireDefault(require("../translate"));

var _projectStatus = _interopRequireDefault(require("../project-status"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var userDetailLink = function userDetailLink(val, row) {
  return /*#__PURE__*/_react.default.createElement("a", {
    className: "icon-link",
    href: "/user/".concat(row.id)
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "icon icon-detail"
  }));
};

var FarmStatus = /*#__PURE__*/function (_React$Component) {
  _inherits(FarmStatus, _React$Component);

  function FarmStatus(props) {
    var _this;

    _classCallCheck(this, FarmStatus);

    _this = _possibleConstructorReturn(this, (FarmStatus.__proto__ || Object.getPrototypeOf(FarmStatus)).call(this, props));
    _this.state = {
      user: [props.user],
      isUserLoading: false
    };
    _this.userColumns = [{
      title: props.t('User'),
      render: function render(val, row) {
        return /*#__PURE__*/_react.default.createElement("span", null, row.first_name, " ", row.last_name);
      },
      prop: 'last_name'
    }, {
      title: props.t('email'),
      prop: 'email'
    }, {
      title: '',
      render: userDetailLink
    }];
    _this.staticTexts = {
      noData: props.t('no data'),
      loading: props.t('loading data')
    };
    return _this;
  }

  _createClass(FarmStatus, [{
    key: "render",
    value: function render() {
      var t = this.props.t;
      return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("h2", {
        id: this.props.userAnchorId
      }, t('User')), this.state.user.length > 0 ? /*#__PURE__*/_react.default.createElement(_datalist.default, {
        keys: ['id'],
        withControls: false,
        enableSort: false,
        initialData: this.state.user,
        columns: this.userColumns,
        staticTexts: this.staticTexts,
        isLoading: this.state.isUserLoading
      }) : /*#__PURE__*/_react.default.createElement("div", {
        className: "space-4"
      }, t('There is no user associated with this farm yet')), /*#__PURE__*/_react.default.createElement(_projectStatus.default, {
        t: t,
        i18n: this.props.i18n,
        history: this.props.history,
        userId: this.props.user.id,
        anchorId: this.props.projectAnchorId
      }));
    }
  }]);

  return FarmStatus;
}(_react.default.Component);

FarmStatus.defaultProps = {
  userAnchorId: 'user-status',
  projectAnchorId: 'project-status'
};
FarmStatus.propTypes = {
  history: _propTypes.default.shape({}),
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string
  }),
  t: _propTypes.default.func.isRequired,
  user: _propTypes.default.object,
  farmId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  userAnchorId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  projectAnchorId: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string])
};

var _default = (0, _translate.default)(FarmStatus);

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/farm-status/index.js
// module id = 747
// module chunks = 0